<div class="catalog-toolbar"
     fxLayout="column"
     [mmTestId]="'PRODUCT_CATALOG.CATALOG_TOOLBAR'">

  <div class="toolbar-search"
       fxLayout="row"
       fxLayoutAlign="start start"
       fxLayout.mm-mobile="column"
       fxLayout.mm-tablet="column"
       fxFlex="100">
    <h1 *ngIf="mustDisplayTitle" id="toolbar-search__title" class="toolbar-search__title" test-target="toolbar-search__title">
      <ng-container *ngIf="(searchTerm && !customTitle); else defaultTitle">
        {{ 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.SEARCH.TEXT' | translate: { searchTerm: (searchCorrection) ? (searchCorrection) : searchTerm } }}
      </ng-container>
    </h1>

    <div class="toolbar-search__count" [ngClass]="{'color-blueGrey':isNewPLPVariantRestyle && isPLP}">
      {{ 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.PRODUCTS_COUNT' | translate: { count: totalCount > defaultProductsLimit ? '10000+' : totalCount} }}
      <div *ngIf="(selectedOption$ | async).code === bestMatchSortOption" class="sort-toggler__info"
           fxLayout="row"
           fxLayoutAlign="center center"
           fxLayoutGap.mm-tablet="6px"
           fxLayoutGap.mm-desktop="6px"
      >
        <app-tooltip class="sort__info-icon"
                     [position]="tooltipPosition"
                     [bulletBackgroundColor]="!isNewPLPVariantRestyle && isPLP ? bulletBackgroundColor : 'transparent'"
                     [bulletTextColor]="bulletTextColor"
                     [withBorders]="true"
                     [fontSize]="10"
                     [height]="12"
                     [width]="12"
                     [bulletIconName]="!isNewPLPVariantRestyle && isPLP ? 'icon_question_mark' : 'icon_question_mark_blue_grey'" >
      <span>
        {{ 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.SORT_TOGGLER.BEST_MATCH.TOOLTIP' | translate }}
      </span>
        </app-tooltip>
      </div>
    </div>
  </div>

  <div
    *ngIf="searchCorrection"
    class="toolbar-search">
    <span class="toolbar-search__correction"> {{ 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.SEARCH.CORRECTION' | translate: { searchTerm: searchTerm } }} </span>
  </div>

</div>

<ng-template #defaultTitle>
  <ng-container *ngIf="customTitle">
    {{ customTitle }}
  </ng-container>
  <ng-container *ngIf="selectedCategory && !customTitle">
    {{ selectedCategory?.name }}
  </ng-container>
  <ng-container *ngIf="!selectedCategory && (hasFilters$ | async) && brandTitle && !customTitle">
    {{ brandTitle }}
  </ng-container>
  <ng-container *ngIf="!selectedCategory && !brandTitle && !customTitle && queryParams?.filter?.promotion">
    {{ 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.PROMOTION_TITLE' | translate }}
  </ng-container>
  <ng-container *ngIf="!selectedCategory && !brandTitle && !customTitle && !queryParams?.filter?.promotion">
    {{ 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.TITLE' | translate }}
  </ng-container>
</ng-template>
